<template>
  <div class="line-box">
      <div class="left-line">
        <img src="../assets/img/line.png" alt="">
      </div>
      <div class="right-box">
        <div class="list">
          <h3>‌中欧线路‌</h3>
          <p>从中国通过哈萨克斯坦、俄罗斯等地，通往欧洲的主要国家，如德国、法国、荷兰、比利时、波兰等</p>
        </div>
        <div class="list">
          <h3>‌中亚线路‌</h3>
          <p>覆盖中亚五国及周边国家，如哈萨克斯坦、乌兹别克斯坦、土库曼斯坦、塔吉克斯坦、吉尔吉斯斯坦等</p>
        </div>
        <div class="list">
          <h3>‌中东线路‌</h3>
          <p>经中国西部至中东地区的核心国家，如土耳其、伊朗、沙特阿拉伯等</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Line",
  props: {
  
  },
   data() {
    return {

    }
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
.line-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 80%;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    height: 100%;
    .left-line {
      width: 66.5%;
      border-radius: 8px;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }
    .right-box {
      height: calc(100% - 20px);
      width: calc(33.5% - 30px);
      border-radius: 8px;
      background: #fff;
      margin-left: 10px;
      padding: 10px;
      .list {
        margin-bottom: 5%;
      }
      h3 {
        font-size: 20px;
        line-height: 34px;
      }
      p {
        font-size: 16px;
        line-height: 24px;
      }
    }
}
</style>